import ReactGA from 'react-ga4';

interface GoogleAnalyticsConfig {
  readonly environment: string;
  readonly measurementId: string;
}

let isInitialized = false;

export const initializeGoogleAnalytics = ({
  environment,
  measurementId,
}: GoogleAnalyticsConfig) => {
  if (environment !== 'production' || !measurementId || isInitialized) {
    return;
  }

  ReactGA.initialize(measurementId, {
    gtagOptions: {
      send_page_view: false,
    },
  });

  isInitialized = true;
};

export const trackGoogleAnalyticsPageView = () => {
  if (!isInitialized) {
    return;
  }

  ReactGA.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
  });
};
